import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import QuestionSetForm from '../../../components/forms/QuestionSetForm';
import { QuestionSetClient, QuestionSetDTO, QuestionSetItemClient, QuestionSetItemDTO } from '../../../services/apiClient';
import { useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from "../../../services/axiosInstance";

const QuestionSetEdit: React.FC = () => {
  const [entityData, setEntityData] = useState<QuestionSetDTO>();
  const [questionSetItems, setQuestionSetItems] = useState<QuestionSetDTO>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const apiClient = new QuestionSetClient(API_BASE_URL, axiosInstance);
  const itemClient = new QuestionSetItemClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Question Sets', href: '/admin/questionsets' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await apiClient.getQuestionSetById(id!);
        setEntityData(response.data);

        // const questionSetItems = await itemClient.getQuestionSetItemById(id!);
        // setQuestionSetItems(questionSetItems.data)

      } catch (error) {
        console.error('Error fetching QuestionSet data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: QuestionSetDTO, items: QuestionSetItemDTO[], itemsToDelete: string[]) => {
    setIsSubmitting(true);
    try {
      const response = await apiClient.updateQuestionSet(id!, data);

      if (response && response.success && response.data?.id) {
        const questionSetId = response.data.id;

        // Prepare all API calls (create or update)
        const itemRequests = items.map((item) => {
          const payload = { ...item, questionSetId };

          if (!item.id || item.id.trim() === '') {
            return itemClient.createQuestionSetItem(payload);
          } else {
            return itemClient.updateQuestionSetItem(item.id, payload);
          }
        });

        // Execute all requests
        await Promise.all(itemRequests);

        // Process any deletes
        if (itemsToDelete.length > 0) {
          await Promise.all(
            itemsToDelete.map((id) => itemClient.deleteQuestionSetItem(id))
          );
        }
      }

      navigate('/admin/questionsets');
    } catch (error) {
      console.error('Error updating QuestionSet:', error);
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <AdminLayout
      title="Edit Question Sets"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card>
        {entityData ? (
          <QuestionSetForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/questionsets')}
          />
        ) : (
          <p>Loading...</p>
        )}
      </Card>
    </AdminLayout>
  );
};

export default QuestionSetEdit;
